import axios from "axios";
import AuthService from "@/services/AuthService";
import UserService from "@/services/UserService";
import AzureAuthService from "@/services/AzureAuthService";
import CompanyService from "../services/CompanyService";

export default {
  namespaced: true,
  state: {
    user: null,
    selectedCompanyId2: null,
    availableCompanies: []
  },
  mutations: {
    logout(state) {
      if (state.deviceToken) {
        UserService.deactivateFcmToken(state.deviceToken).then(() => {
        }).catch((error) => {
          console.log(error);
        })
      }
      state.user = null;
    },
    setUser: (state, value) => {
      state.user = value;
      if (state.user.company.color == "" || state.user.company.color == null || state.user.company.color == "#33a646") {
        document.documentElement.style.setProperty("--primary", '#335b3A');
      }
      else {
        document.documentElement.style.setProperty("--primary", state.user.company.color);
      }

      if (state.deviceToken) {
        UserService.activateFcmToken(state.deviceToken).then(() => {
        }).catch((error) => {
          console.log(error);
        })
      }
    },
    setDeviceToken: (state, value) => {
      state.deviceToken = value;
      if (state.user) {
        UserService.activateFcmToken(state.deviceToken).then(() => {
        }).catch((error) => {
          console.log(error);
        })
      }
    },
    setSelectedCompanyId2(state, id) {
      state.selectedCompanyId2 = id;
    },
    setAvailableCompanies(state, value) {
      state.availableCompanies = value;
    }
  },
  actions: {
    initStore({ commit, state, dispatch }) {
      return new Promise((resolve, reject) => {

        if (!state.user && localStorage.getItem("user")) {

          let token = localStorage.getItem("token");
          if (token) {
            axios.defaults.headers.common["Authorization"] = "Token " + token;
          }

          CompanyService.getMyAvailableCompanies().then((companies) => {
            commit("setAvailableCompanies", companies);

            UserService.getMyProfile().then((user) => {
              commit("setUser", user);

              dispatch("app/setFrontendLanguage", user.active_language, {
                root: true
              });

              resolve();
            }).catch((err) => {
              resolve();
            });
          }).catch((err) => {
            resolve();
          });
        } else {
          resolve();
        }
      });
    },
    setUser({ commit }, value) {
      commit("setUser", value);
      localStorage.setItem("user", JSON.stringify(value));
    },
    setDeviceToken({ commit }, value) {
      commit("setDeviceToken", value);
    },
    logout({ commit }) {
      if (localStorage.getItem("azureUser") == "true") {
        commit("logout");
        delete axios.defaults.headers.common["Authorization"];
        commit("setSelectedCompanyId2", "");
        commit("setAvailableCompanies", []);
        localStorage.clear();
        return AzureAuthService.logout().then(() => {

        });
      }
      else {
        return AuthService.logout().then(() => {
          commit("logout");
          delete axios.defaults.headers.common["Authorization"];
          commit("setSelectedCompanyId2", "");
          localStorage.clear();
        });
      }
    },
    setSelectedCompanyId2({ commit }, id) {
      commit("setSelectedCompanyId2", id);
      localStorage.setItem("selectedCompanyId2", JSON.stringify(id));
    },
    setAvailableCompanies({ commit }, value) {
      commit("setAvailableCompanies", value);
    },
    clear({ commit }) {
      commit("logout");
      delete axios.defaults.headers.common["Authorization"];
      commit("setSelectedCompanyId2", "");
      commit("setAvailableCompanies", []);
      localStorage.clear();
    }
  },
  getters: {
    company: (state) => {
      return state.user.company;
    },
    user: (state) => {
      let user = state.user;
      return user;
    },
    selectedCompanyId2: (state) => {
      return state.selectedCompanyId2;
    },
    availableCompanies: (state) => {
      return state.availableCompanies;
    }
  }
};
